module.exports = __webpack_public_path__ + "img/marca-de-verificacion.3f79f16d.svg";